import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RouteLoading } from '../components/feedback/RouteLoading';
import { AppShell } from './shell/AppShell';

const hydrateFallback = <RouteLoading />;

export const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/app" replace /> },
  { path: '/entrar', hydrateFallbackElement: hydrateFallback, lazy: () => import('../features/auth/SignInPage') },
  {
    path: '/app',
    element: <AppShell />,
    hydrateFallbackElement: hydrateFallback,
    children: [
      { index: true, lazy: () => import('../features/dashboard/DashboardPage') },
      { path: 'estudar', lazy: () => import('../features/study/StudyPage') },
      { path: 'biblioteca', lazy: () => import('../features/library/LibraryPage') },
      { path: 'calendario', lazy: () => import('../features/calendar/CalendarPage') },
      { path: 'disciplinas', lazy: () => import('../features/disciplines/DisciplinesPage') },
      { path: 'questoes', lazy: () => import('../features/questions/QuestionsPage') },
      { path: 'prova/:simulationId?', lazy: () => import('../features/exams/ExamPage') },
      { path: 'comunidade', lazy: () => import('../features/community/CommunityPage') },
      { path: 'evolucao', lazy: () => import('../features/stats/StatsPage') },
      { path: 'perfil', lazy: () => import('../features/profile/ProfilePage') },
      { path: 'configuracoes', lazy: () => import('../features/settings/SettingsPage') },
    ],
  },
  { path: '*', element: <Navigate to="/app" replace /> },
]);
